import { render, staticRenderFns } from "./application_announcement_service_appendix2.vue?vue&type=template&id=79da24d0&scoped=true&"
import script from "./application_announcement_service_appendix2.vue?vue&type=script&lang=js&"
export * from "./application_announcement_service_appendix2.vue?vue&type=script&lang=js&"
import style0 from "./application_announcement_service_appendix2.vue?vue&type=style&index=0&id=79da24d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da24d0",
  null
  
)

export default component.exports